import React from 'react';
import styled from 'styled-components';

import { size } from '../layout/helpers';
import Button from '../Button';
import { H3 } from '../Heading';

const StyledSliceWrapper = styled.div``;

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${size(2)};
`;

const Content = styled.div`
  flex: 1 1 auto;
`;

const Preamble = styled.div``;

const Link = styled.div`
  flex-shrink: 0;
`;

const Footer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${size(2)};
`;

interface ILink {
  text: string;
  url: string;
}

const defaultLinkRenderer = ({ text, url }: ILink) => (
  <Button as="a" href={url} title={text} tone="ghost">
    {text}
  </Button>
);

interface ISliceWrapper {
  children?: React.ReactNode;
  heading?: string;
  preamble?: string;
  link?: ILink;
  renderLink?: (link: ILink) => JSX.Element;
  linkPos: 'Top' | 'TopBottom';
  titleHeadingLevel?: number;
  style?: React.CSSProperties;
}

const SliceWrapper = ({
  children,
  heading,
  link,
  linkPos,
  renderLink = defaultLinkRenderer,
  preamble,
  titleHeadingLevel,
  ...props
}: ISliceWrapper & React.ComponentPropsWithRef<'div'>) => (
  <StyledSliceWrapper {...props}>
    {(heading || preamble || link) && (
      <Header>
        <Content>
          {heading && <H3 as={titleHeadingLevel === 1 ? 'h1' : 'h2'}>{heading}</H3>}
          {preamble && <Preamble>{preamble}</Preamble>}
        </Content>
        {link && <Link>{renderLink(link)}</Link>}
      </Header>
    )}
    {children}
    {link && linkPos === 'TopBottom' && <Footer>{renderLink(link)}</Footer>}
  </StyledSliceWrapper>
);

export default SliceWrapper;
